import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import "../../../constants/index.js";
import useDateAvailCheck from "../../../hooks/useDateAvailCheck.js";
import { detectFbIab, detectLineIab, detectIosDevice } from "../../../utils/browser.js";
import moment from "moment";
import { useState, useRef, useEffect, useCallback } from "react";
import Dialog from "../../utils/Dialog/Dialog.js";
const THREE_DAYS = 24 * 60 * 60 * 3;
const PWA_REMINDER_KEY = "pwa-reminder";
const PwaInstaller = ({
  children,
  reminderPeriod = THREE_DAYS,
  reminderKey = PWA_REMINDER_KEY,
  hideOnPWA = true,
  onInstalled,
  onDismissed,
  withInstructions = true,
  instructionOptions,
  onInstallable
}) => {
  const [installable, setInstallable] = useState(false);
  const deferredPrompt = useRef();
  const [openExtBrowserInstruction, setOpenExtBrowserInstruction] = useState(false);
  const [openShareAddHomeScreenInstruction, setOpenShareAddHomeScreenInstruction] = useState(false);
  const { dueAt: nextDisplayAt, updateDueAt: setNextDisplayAt } = useDateAvailCheck(reminderKey);
  useEffect(() => {
    onInstallable == null ? void 0 : onInstallable(installable);
  }, [installable, onInstallable]);
  useEffect(() => {
    const isDisplaying = nextDisplayAt ? moment().isAfter(nextDisplayAt) : true;
    if (!isDisplaying) {
      return;
    }
    if (hideOnPWA) {
      const displayMode = sessionStorage.getItem("display-mode");
      if (displayMode === "standalone") {
        return;
      }
    }
    const beforeInstallPromptHandler = (e) => {
      e.preventDefault();
      deferredPrompt.current = e;
      setInstallable(true);
    };
    const appInstalledHandler = () => {
      onInstalled == null ? void 0 : onInstalled();
    };
    window.addEventListener("beforeinstallprompt", beforeInstallPromptHandler);
    window.addEventListener("appinstalled", appInstalledHandler);
    return () => {
      window.removeEventListener("beforeinstallprompt", beforeInstallPromptHandler);
      window.removeEventListener("appinstalled", appInstalledHandler);
    };
  }, [hideOnPWA, nextDisplayAt, onInstalled]);
  const doInstall = useCallback(() => {
    var _a, _b;
    setInstallable(false);
    (_a = deferredPrompt.current) == null ? void 0 : _a.prompt();
    (_b = deferredPrompt.current) == null ? void 0 : _b.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        onInstalled == null ? void 0 : onInstalled();
      } else {
        setInstallable(true);
        onDismissed == null ? void 0 : onDismissed();
      }
    });
  }, [onDismissed, onInstalled]);
  const handleClose = useCallback(() => {
    setNextDisplayAt(moment().add(reminderPeriod, "seconds"));
    setInstallable(false);
  }, [reminderPeriod, setNextDisplayAt]);
  const handleInstall = useCallback(() => {
    if (detectFbIab() || detectLineIab()) {
      setOpenExtBrowserInstruction(true);
      return;
    }
    if (detectIosDevice()) {
      setOpenShareAddHomeScreenInstruction(true);
      return;
    }
    doInstall();
  }, [doInstall]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    installable && children(handleInstall, handleClose),
    /* @__PURE__ */ jsx(
      Dialog,
      {
        open: openExtBrowserInstruction,
        onClose: () => setOpenExtBrowserInstruction(false),
        title: instructionOptions == null ? void 0 : instructionOptions.openExtBrowser.title,
        classes: {
          "title&": "!mb-4"
        },
        children: /* @__PURE__ */ jsx(
          "video",
          {
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            className: "rounded-xl",
            children: /* @__PURE__ */ jsx(
              "source",
              {
                src: instructionOptions == null ? void 0 : instructionOptions.openExtBrowser.videoSrc,
                type: "video/mp4"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      Dialog,
      {
        open: openShareAddHomeScreenInstruction,
        onClose: () => setOpenShareAddHomeScreenInstruction(false),
        title: instructionOptions == null ? void 0 : instructionOptions.openShareAddHomeScreen.title,
        classes: {
          "title&": "!mb-4"
        },
        children: /* @__PURE__ */ jsx(
          "video",
          {
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            className: "rounded-xl",
            children: /* @__PURE__ */ jsx(
              "source",
              {
                src: instructionOptions == null ? void 0 : instructionOptions.openShareAddHomeScreen.videoSrc,
                type: "video/mp4"
              }
            )
          }
        )
      }
    )
  ] });
};
const PwaInstaller$1 = PwaInstaller;
export {
  PwaInstaller$1 as default
};
